import { styled } from '@mui/material/styles';
import { Chip } from 'shared/mui/Chips';

export const StyledLinkedChipAll = styled(Chip)(({ theme }) => ({
  background: theme.palette.primary.main,
  marginTop: '12px',
  cursor: 'pointer',
  marginBottom: 0,
  '& .MuiChip-label': {
    color: '#fff',
  },
}));

export const StyledChip = styled(Chip)<{ isLast: boolean }>(({ theme, isLast }) => ({
  marginBottom: isLast ? '0' : '12px',
  cursor: 'pointer',
  '& .MuiChip-label': {
    color: theme.palette.primary.main,
  },
}));
